import React from 'react';
import { useRef, useEffect } from 'react';

import agentPageStore from '../store';
import { observer } from 'mobx-react-lite';
import { McpAgentType } from '@shared/constants/mcp';
import urlStore from '@/store/chat/urlStore';
import AagentMenu from './agent-menu';
import TipsMcp from './tips-mcp';
import Conf from '@/common/conf';
import TipsSuper from './tips-super';
import globalStore from '@/store/global';

const BlockListItem = ({ item }) => {
  /** 跳转去聊天 */
  const gotoChat = () => {
    if (item.agent_type == McpAgentType.old) {
      urlStore.newAgentChat(item.id);
    } else {
      agentPageStore.gotoAgentChat(item.id);
    }
  };

  return (
    <div
      onClick={gotoChat}
      key={item.id}
      className={[
        'relative group bg-white hover:bg-[#f7f7f7]',
        'flex items-center h-118px px-16px cursor-pointer rounded-8px',
        //showDropdown ? 'bg-[rgba(0,0,0,0.03)]' : '',
      ]}
    >
      <div className={['size-64px', 'mr-12px rounded-full overflow-hidden']}>
        <img
          src={item.flow_images || Conf.agentIocn}
          className="size-full object-cover"
          alt=""
        />
      </div>

      <div className="flex-grow w-0">
        <div className="w-full flex items-center text-16px text-black font-bold leading-22px mb-2px truncate">
          <div className="truncate">{item.flow_title}</div>
        </div>
        <div className="text-12px text-black leading-17px my-4px line-clamp-2">
          {item.flow_desc}
        </div>
        <div className="text-12px text-black text-opacity-50 leading-20px truncate">
          创建者：{item.tag_name}
        </div>
      </div>
    </div>
  );
};

const BlockList = observer(({ list, className }) => {
  const disTop = -31;
  const magicRef = useRef(null);
  const topTabRef = useRef(null);
  //滚动时切换tab
  console.log('scroll is', scroll);
    useEffect(() => {
      if (scroll - magicRef?.current?.offsetTop >= ( -104)) {
        agentPageStore.switchTab(11);
      }
      if (topTabRef.current) {
        agentPageStore.toggleTopTab(
          scroll > topTabRef.current.parentNode.offsetTop
        );
      }
    }, [scroll]);
  return (
    <div
      ref={magicRef}
      className={[
        'relative',
        'last:min-h-[calc(100vh-20px)]',
        'py-16px',
        className,
      ]}
    >
      <div
        style={{ top: disTop }}
        className="list-item-magic absolute size-0"
      ></div>

      <>
        <div
          className={['mb-4px text-black font-bold', 'text-16px leading-22px']}
        >
          工作流
        </div>

        <div className="text-14px leading-20px mb-16px text-black text-opacity-50">
          工作流详细
        </div>
        <div className={['w-full grid gap-16px grid-cols-2']}>
          {list.map(item => {
            return <BlockListItem key={item.id} item={item} />;
          })}
        </div>
      </>
    </div>
  );
});

export default BlockList;
